import {PATH_DASHBOARD} from '@feg/ui'
import {useTranslation} from 'react-i18next'
import TermCategoryList from '../../../components/admin/termTaxonomy/TermCategoryList'
import AddEditTermCategoryButton from '../../../components/admin/termTaxonomy/AddEditTermCategoryButton'
import {PageRoot} from "@feg/ui/src/common/layout/PageRoot";


export default function TermCategoryPage() {
    const {t} = useTranslation()
    return (
        <PageRoot title={t('termCategory.list.main')}
                  breadcrumbs={{
                      heading: t('termCategory.list.main'),
                      links: [
                          {name: t('dashboard.main'), href: PATH_DASHBOARD.general.app},
                          {name: t('termCategory.list.main'), href: PATH_DASHBOARD.admin.termCategory}
                      ],
                      action: (
                          <AddEditTermCategoryButton/>
                      )
                  }}>
            <TermCategoryList/>
        </PageRoot>
    )
}


